module.exports = __webpack_public_path__ + "assets/images/electoral-college/diverging-votes/desktop.svg?v=7b743f59";